/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CaseResourceDto } from '../../models/case-resource-dto';

export interface GetCaseResourceById$Params {
  id: number;
  ignoreEndDate?: boolean;
}

export function getCaseResourceById(http: HttpClient, rootUrl: string, params: GetCaseResourceById$Params, context?: HttpContext): Observable<StrictHttpResponse<CaseResourceDto>> {
  const rb = new RequestBuilder(rootUrl, getCaseResourceById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('ignoreEndDate', params.ignoreEndDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CaseResourceDto>;
    })
  );
}

getCaseResourceById.PATH = '/case-resources/{id}';
